import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import Projects from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import { buildFilterString } from "../Services/Helper";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import SidebarFilter from "../Common/SidebarFilter";
import { Drawer } from "@mui/material";

function ViewAllListing() {
  const [open, setOpen] = useState(false);

  const location = useLocation();
    const initialFilters = location?.state?.filters || new FilterParams();

  const [filters, setFilters] = useState(initialFilters);

  const params = new URLSearchParams(location.search);
  const tabID = params.get("tabID");
 // const filters = location?.state?.filters;

  const [data, setdata] = useState([]);

  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    getSearchResults(filters);
  }, [filters]);

  const getSearchResults = (filters) => {
    setLoading(true);

    const mongoFilterString = buildFilterString(filters);

    // console.log("Mongo Filter String:", mongoFilterString);

    getRecords(tabID, 100, `{${mongoFilterString}}`, 1, "", (res) => {
      // console.log("Search Results:", res);

      if (res.hasErrors === false) {
        if (res?.response?.records != null) {
          if (LoggedInUserID != null && initialFilters.my == null) {
            setdata(
              (res?.response?.records || []).filter(
                (item) => item.SellerID != LoggedInUserID
              )
            );
          } else {
            setdata(res?.response?.records || []);
          }

          setLoading(false);
        } else {
          setdata([]);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

 // console.log("Filters in ViewAllListing:", tabID, filters);
  return (
    <>
      <Header />

      <div className="content-wrapper">
        {/* <div className="breadcrumb-wrap bg-f br-1">
          <div className="container">
            <div className="breadcrumb-title">
              <h2>Feassssured Properties</h2>
            </div>
          </div>
        </div> */}
        {/* Breadcrumb End */}

        {/* Listing section start */}
        <section className="listing-wrap ptb-50">
          <div className="container">
            <div className="row gx-5">
              <div className="col-xl-4 d-desk">
                <div className="">
                  <SidebarFilter filters={filters} onChange={setFilters} />
                </div>
              </div>
              <div className="col-xl-8">
                <div className="headingtop style4 mb-15">
                  <div className="row">
                    <div className="fblock topsearch">
                      <div className="form-group">
                        <form  className="search-form d-flex">
                          <input
                            type="text"
                            placeholder="Search Properties, Location..."
                          />
                          <button
                          onClick={(e)=>{  e.preventDefault()}}
                           
                            className="btn style2"
                            style={{ padding: "0px 39px 0px 18px" }}
                          >
                            Search
                          </button>

                          <button
                            
                            className="btn style2 btnx d-mobile"
                            style={{
                              padding: "0px 39px 0px 14px",
                              marginLeft: 10,
                            }}
                            onClick={(e) => {
                              setOpen(true);
                              e.preventDefault();

                            }}
                          >
                            <i className="ri-filter-3-fill"></i> Filter
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" style4 mb-25">
                  <div className="row align-items-center">
                    <div className="col-md-8">
                      <div className="profuct-result">
                        <h5 style={{ marginBottom: 0 }}>
                          {data?.length || 0} Results Found
                        </h5>
                        {/* <p>in Noida Sector 62</p> */}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="filter-item-cat">
                        <select>
                          <option value={1}>Relevance</option>
                          <option value={2}>Price : High To Low</option>
                          <option value={3}>Price : Low To High</option>
                          <option value={3}>Newest First</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {data?.length > 0 &&
                    data?.map((item, index) => (
                      <FeaturedProperty key={index} {...item} />
                    ))}
                  {data?.length == 0 && !Loading && (
                    <div className="col-12">
                      <h3>No Properties Found</h3>
                    </div>
                  )}
                  {/* <div className="col-lg-64 col-md-4">
                    <div className="property-card style2">
                      <div className="property-img-slider">
                        <img
                          src="assets/img/property/property-10.jpg"
                          alt="Image"
                        />
                      </div>
                      <div className="property-info">
                        <div className="property-status-wrap">
                          <span className="property-status">For Rent</span>
                          <p className="property-price">
                            $34,900/<span>month</span>
                          </p>
                        </div>
                        <h3>
                          <a href="listing-details.html">Villa In Luis Park</a>
                        </h3>
                        <p>
                          <i className="flaticon-location" />
                          64, 1st Aveneu, High Steet, USA
                        </p>
                        <ul className="property-metainfo list-style">
                          <li>
                            <i className="flaticon-double-bed" />
                            06
                          </li>
                          <li>
                            <i className="flaticon-bath-tub" />
                            04
                          </li>
                          <li>
                            <i className="flaticon-square" />
                            3100 sqft
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Listing section end */}
        {Loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(255,255,255,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <TailSpin color="#00BFFF" height={80} width={80} />
          </div>
        )}

        <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)}>
          <div className="bottomdrawer">
            <SidebarFilter />
          </div>
        </Drawer>
      </div>
      <Footer />
    </>
  );
}

export default ViewAllListing;
